import React, { Component } from 'react';
import { connect } from 'react-redux';
import B2bProfileView from './B2bProfileView';
import { setTokenAction } from '../../store/Layout/actions';
import { setTranslationsAction } from '../../store/B2b/actions';
import { setCurrentTabAction } from '../../store/Login/actions';
import ApiManager from '../../apiManager';
import ErrorModal from '../Fragments/ErrorModal';
import Loading from '../Fragments/Loading';
import { trans } from '../../helpers';

class B2bProfileController extends Component {

    constructor( props ){
        super( props );

        this.state = {
            showErrorModal: false
        };

    }

    componentDidMount(){

        ApiManager.getB2bTranslations().then(( resolve ) => {
            this.props.setTranslationsAction( resolve.data );
        }, () => {
            this.setState({ showErrorModal: true });
        });

    }

    errorModal(){

        if ( !this.state.showErrorModal ) {
            return '';
        }

        return (
            <ErrorModal
                title={trans( this.props.b2bTrans, 'b2b.error.modal.title' )}
                description={trans( this.props.b2bTrans, 'b2b.error.modal.description' )}
                action_text={trans( this.props.b2bTrans, 'b2b.error.modal.action_text' )}
            />
        );

    }

    render(){

        if ( this.props.b2bTrans === '' ) {
            return <Loading />;
        }

        return(
            <>
                <B2bProfileView
                    b2bTrans={this.props.b2bTrans}
                    csrf_token={this.props.csrf_token}
                    setTokenAction={this.props.setTokenAction}
                    setTranslationsAction={this.props.setTranslationsAction}
                    setCurrentTabAction={this.props.setCurrentTabAction}
                />
                {this.errorModal()}
            </>
        );

    }

}

const mapStateToProps = state => {

    return {
        csrf_token: state.layout.csrf_token,
        b2bTrans: state.b2b.b2bTrans,
        loginToken: state.login.loginToken
    }

};

const mapDispatchToProps = {
    setTokenAction,
    setTranslationsAction,
    setCurrentTabAction
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( B2bProfileController );